import { CRYPTO_KEY } from "@/config/app.config";

import CryptoJS from "crypto-js";

// 加密函数
export function encryptData(data) {
  if (!data) return null;

  const encrypted = CryptoJS.AES.encrypt(data, CRYPTO_KEY);
  return encrypted.toString();
}

// 解密函数
export function decryptData(encryptedData) {
  if (!encryptedData) return null;
  const decrypted = CryptoJS.AES.decrypt(encryptedData, CRYPTO_KEY);
  return decrypted.toString(CryptoJS.enc.Utf8);
}
